import React from 'react';
// import ReactDOM from 'react-dom/client';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { PostHogProvider } from '@posthog/react';
import './index.css';
import './globals.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import { makeServer } from './dev-server/mirageServer';
import ContextProvider from './context/context';
import { BrowserRouter } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { installMutationRequestGuard } from './lib/installMutationRequestGuard';
import { installRequestTooLargeAlert } from './lib/installRequestTooLargeAlert';
import { GeneralError } from './components/errors/general-error';
import { UpdateBanner } from './components/update-banner';
import { RequestTooLargeDialog } from './components/request-too-large-dialog';
import { initPostHog, isPostHogEnabled, posthogClient, syncPostHogRoute } from './lib/posthog';
import { getCanonicalTenantUrl } from './utilities/client-id';

// Check if we're in development mode before starting Mirage
// if (process.env.NODE_ENV === 'development') {
//   makeServer();
// }

window.__leasehubSentryDebug = {
    app: 'client',
    configured: Boolean(import.meta.env.VITE_SENTRY_DSN),
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE || null,
    mode: import.meta.env.MODE,
};

if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
        release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
        tracesSampleRate: 0,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
    });
    if (import.meta.env.MODE !== 'production') {
        window.Sentry = Sentry;
    }
}

initPostHog();
installMutationRequestGuard();
installRequestTooLargeAlert();

document.documentElement.classList.remove('dark');
document.documentElement.classList.add('light');
document.cookie = 'vite-ui-theme=light; path=/; max-age=31536000';

// const root = ReactDOM.createRoot(document.getElementById('root'));c
const root = ReactDOM.createRoot(document.getElementById('root'), {
    hydrate: false,
});

const PostHogRouteSync = () => {
    const location = useLocation();

    React.useEffect(() => {
        syncPostHogRoute(location.pathname, location.search);
    }, [location.pathname, location.search]);

    return null;
};

const app = (
    // <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<GeneralError />}>
        <BrowserRouter>
            <PostHogRouteSync />
            <ContextProvider>
                <UpdateBanner />
                <RequestTooLargeDialog />
                <App />
            </ContextProvider>
        </BrowserRouter>
    </Sentry.ErrorBoundary>
    // </React.StrictMode>
);

const canonicalTenantUrl = getCanonicalTenantUrl(window.location.href);
if (canonicalTenantUrl) {
    // Redirect old shared links before mounting providers that fetch tenant data.
    window.location.replace(canonicalTenantUrl);
} else {
    root.render(
        isPostHogEnabled ? <PostHogProvider client={posthogClient}>{app}</PostHogProvider> : app
    );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
//deploy
